import { AxiosError } from "axios";
import { type } from "os";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useTranslateMutation = () => {
  return useMutation<
    { translation: {
      id: number, input: string, output: string
    } },
    AxiosError<any>,
    {
      inputText: string;
      fromLang?: string;
      toLang: string;
    }
  >(
    ({ inputText, fromLang, toLang }) => {
      const body = new FormData();
      
      body.append("toLang",toLang);
      body.append('inputText', inputText);

      if(fromLang){
        body.append("fromLang", fromLang);
      }
      
      return axiosClient
        .post(`/translation/text`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 60 * 1000, // 1min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
